import { createFileRoute } from '@tanstack/react-router';
import { useAdminAuthGuard } from '@/features/admin/hooks';
import { PredicateRunsPanel } from '@/features/admin/PredicateRunsPanel';
import { AdminShell } from '@/features/admin/components/AdminShell';
import { AdminPageHeader } from '@/features/admin/components/AdminPageHeader';
import { AdminLogoutButton } from '@/features/admin/components/AdminLogoutButton';

/**
 * Admin Predicate Runs route — platform operator's view of every in-flight
 * (queued/running) predicate finder run plus recent failures, with Kill / Retry
 * and the concurrency dial. Bounces to /admin/login if the admin cookie isn't set.
 */
export const Route = createFileRoute('/admin/predicate-runs')({
  component: AdminPredicateRunsPage,
});

function AdminPredicateRunsPage() {
  useAdminAuthGuard();
  return (
    <AdminShell actions={<AdminLogoutButton />}>
      <AdminPageHeader
        title="Predicate Runs"
        subtitle="Every predicate finder run currently queued or running, across all companies, plus recent failures. Stale runs (a worker likely died) are highlighted. Kill a wedged run to fail it now, or Retry a failed one for a fresh attempt."
      />
      <PredicateRunsPanel />
    </AdminShell>
  );
}
